export const GATE_TYPES = [
  { name: "dedicated", id: 1 },
  { name: "carpull", id: 2 },
  { name: "guest", id: 3 },
];
